var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),(_vm.bg)?_c('div',{staticClass:"top"},[_c('el-image',{attrs:{"src":_vm.hbgsrc,"fit":"cover"}}),_vm._t("slogan")],2):_vm._e(),_vm._t("body"),_c('Footer')],2)}
var staticRenderFns = []

export { render, staticRenderFns }